
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexOnYA_e5GU0jTIGBYcXwP4ecK1EQppghIlyoU1_RPE9gMeta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/index.vue?macro=true";
import { default as loginQw7m7mFfY8SNBojyAP95yCMgpg9mKtQKvsDpQoK83awMeta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/login.vue?macro=true";
import { default as issuesM4GLNEVSHGmb_Wfv5G3PD66TUyvWg42bVabW1TBRuVsMeta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/issues.vue?macro=true";
import { default as categories7NtErzSIZTiGEau27rumgepVmEXkrcJAdJg_45w6ymav0Meta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/categories.vue?macro=true";
import { default as roles54YWXOuxYL0nEuaOvhNoy_45_45rkbyxkQQOBsZ9RciVwMAMeta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/admin/roles.vue?macro=true";
import { default as userseB4I9ysyz_uoNv4jVX19TIiEvQLtiYHG88_45v_45WzdQjwMeta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/admin/users.vue?macro=true";
import { default as notificationSettingsQT92c9FW6q96Lvi4DsrwA66J9KoZ91zgTPYCaIIh44gMeta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/notificationSettings.vue?macro=true";
import { default as permissionss79ZkNI3PkVQhT80_jLdRZB7Lvsc6OknuqeGTbLdkB4Meta } from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/admin/role/permissions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexOnYA_e5GU0jTIGBYcXwP4ecK1EQppghIlyoU1_RPE9gMeta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginQw7m7mFfY8SNBojyAP95yCMgpg9mKtQKvsDpQoK83awMeta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/login.vue")
  },
  {
    name: "issues",
    path: "/issues",
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/issues.vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categories7NtErzSIZTiGEau27rumgepVmEXkrcJAdJg_45w6ymav0Meta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/categories.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: roles54YWXOuxYL0nEuaOvhNoy_45_45rkbyxkQQOBsZ9RciVwMAMeta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/admin/roles.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: userseB4I9ysyz_uoNv4jVX19TIiEvQLtiYHG88_45v_45WzdQjwMeta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/admin/users.vue")
  },
  {
    name: "notificationSettings",
    path: "/notificationSettings",
    meta: notificationSettingsQT92c9FW6q96Lvi4DsrwA66J9KoZ91zgTPYCaIIh44gMeta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/notificationSettings.vue")
  },
  {
    name: "admin-role-permissions",
    path: "/admin/role/permissions",
    meta: permissionss79ZkNI3PkVQhT80_jLdRZB7Lvsc6OknuqeGTbLdkB4Meta || {},
    component: () => import("/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/pages/admin/role/permissions.vue")
  }
]